module.exports = __webpack_public_path__ + "static/urban1-1e21a9491017eab166480df7a4e64c16.jpg";